import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { Box, Typography, CircularProgress } from '@mui/material';
import {
  makeSaleMngCostData,
  makeSalesMngCostHeader,
} from '../../utils/sales_mng_cost_stats';
import * as salesCostsApi from '../../lib/api/salesCosts';
import SalesMngCostStatsTable from '../../components/sales_mng_cost_stats/SalesMngCostStatsTable';

//----------------------------------------------------------------------
const SalesMngCostStatsHqContainer = ({ selectedYear, tableRef }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [headerRows, setHeaderRows] = useState(null);

  useEffect(async () => {
    if (selectedYear) {

      setLoading(true);

      const headers = makeSalesMngCostHeader();
      setHeaderRows(headers);
      // console.log(headers, 'headers');
//      const tempData = makeSaleMngCostData();
//      alert('a');
//      console.log(JSON.stringify(tempData));
       //const response = salesCostsApi.getSalesCostsStaticTotal(selectedYear);   
       
    try {
      const res = await salesCostsApi.getSalesCostsStaticTotal(selectedYear);
      if (res.data.list) {
        setData(res.data.list);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }

    setLoading(false);

       //console.log(response);

    //    setData(response.data);
//      setData(tempData);
    }
  }, [selectedYear]);

  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      {loading ? (
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      ) : Array.isArray(data) && data.length === 0 ? (
        <Box>
          <Typography variant="subtitle2">데이터가 없습니다.</Typography>
        </Box>
      ) : (
        <SalesMngCostStatsTable
          data={data}
          loading={loading}
          headerRows={headerRows}
          tableRef={tableRef}
        />
      )}
    </Box>
  );
};
//----------------------------------------------------------------------
export default SalesMngCostStatsHqContainer;
